import { SimpleDropdown } from '@cleartax/wg-library-simple-dropdown';
import { THeader } from '../../../../../../pages/services/[planSeoSlug]/api/types';
import { TCategories } from '../mobile-header';
import { geHeaderCategory } from '../utils';
import { CategoryDropDown } from './index';

interface ICategoryNavbarButtonDesktop {
  category: TCategories;
  headerData: THeader;
  className?: string;
  dropdownClassName?: string;
}
export const CategoryNavbarButtonDesktop: React.FC<
  ICategoryNavbarButtonDesktop
> = ({
  category,
  headerData,
  className = 'text-brand-1000 pl-8',
  dropdownClassName = 'origin-top-right absolute sm:relative left-5 mt-2 rounded-lg shadow-md sm:shadow-none focus:outline-none',
}) => {
  const dropdownText = category === 'individual' ? 'Individuals' : 'Businesses';
  const categoryToRender = geHeaderCategory(headerData, category);
  return (
    <SimpleDropdown
      dropDownText={dropdownText}
      dropdownContent={
        categoryToRender ? (
          <CategoryDropDown
            categoryData={categoryToRender}
            className={dropdownClassName}
          />
        ) : null
      }
      className={className}
    ></SimpleDropdown>
  );
};
